import { ITracker } from "../interfaces/tracker.interface";
import { BaseChainableComponent } from "./pipeline/base-chainable-component";

export class BaseChainableBobComponent<OutputType> extends BaseChainableComponent<OutputType> {

	constructor(
		protected tracker: ITracker
	) {
		super();
	}

}
